import { useMap } from '@vis.gl/react-google-maps'
import React, { useEffect, useState } from 'react'
import { CoordType } from '.'

interface Props {
  position: { lng: number, lat: number }
  radius: number
  handleChangeMarkerPosition: (data: CoordType) => void
}

const Radius: React.FC<Props> = ({ position, radius, handleChangeMarkerPosition }) => {
  const map = useMap()
  const [circle, setCircle] = useState<google.maps.Circle | null>(null)

  useEffect(() => {
    if (map && position) {
      if (circle) {
        google.maps.event.clearInstanceListeners(circle)
        circle.setMap(null)
      }

      const newCircle = new google.maps.Circle({
        center: position,
        radius: radius * 1000,
        map,
        fillColor: 'rgba(0, 0, 255, 0.3)',
        strokeColor: '#0000FF',
        strokeWeight: 2,
        clickable: true
      })

      newCircle.addListener('click', (event: google.maps.MapMouseEvent) => {
        handleChangeMarkerPosition(event.latLng.toJSON())
      })

      setCircle(newCircle)
    }

    return () => {
      if (circle) {
        google.maps.event.clearInstanceListeners(circle)
        circle.setMap(null)
      }
    }
  }, [map, position, radius])

  return null
}

export default Radius
